import { createContext, useContext } from 'react';

// The Companion context object and its hook live here, away from the provider
// component, so the provider file exports only a component (React fast refresh)
// and every screen imports the hook from one place.
export const CompanionContext = createContext(null);

export function useCompanion() {
  const v = useContext(CompanionContext);
  if (!v) throw new Error('useCompanion must be used inside CompanionProvider');
  return v;
}
